export const URL_DISABLED_FOOTER: string[] = [
  '/backoffice',
  '/parceiro',
  '/selecionar-perfil',
  '/selecionar-contrato',
  '/fale-conosco'
];
